export interface FileDataSummary {
  compoundCount?: number | null;
  biologicalDataPointCount?: number | null;
  biologicalEntityCount?: number | null;
  dataSummaryStatus?: string;
  sourceFileHash?: string | null;
}

export const DATA_POINT_DESCRIPTION = 'Recorded numeric biological measurements associated with this file. Metadata, missing values and replicate totals are excluded. Copies with the same source/measurement ID count once. Unrecognised formats or endpoints are not inferred.';

export function formatDataCount(value?: number | null): string {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value.toLocaleString() : '—';
}

// Reuse indexed counts only for the same bytes, filename and project. A same-name
// document with a different version must never inherit stale source-file counts.
export function withFileDataSummary<T extends FileDataSummary & {project_id: number; original_filename: string}>(
  doc: T,
  files: Array<FileDataSummary & {projectId?: number; originalFileName?: string; fileName: string}>,
): T & FileDataSummary {
  if (doc.dataSummaryStatus === 'indexed' || !doc.sourceFileHash) return doc;
  const matches = files.filter(f => f.projectId === doc.project_id &&
    (f.originalFileName || f.fileName).toLowerCase() === doc.original_filename.toLowerCase() &&
    f.sourceFileHash === doc.sourceFileHash && f.dataSummaryStatus === 'indexed');
  if (matches.length !== 1) return doc;
  const f = matches[0];
  return {...doc, compoundCount: f.compoundCount, biologicalDataPointCount: f.biologicalDataPointCount,
    biologicalEntityCount: f.biologicalEntityCount, dataSummaryStatus: f.dataSummaryStatus};
}
